module.exports = __webpack_public_path__ + "static/img/hq100.3b0dbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/hq100.png
// module id = ppVM
// module chunks = 7